'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotWaterfallIcon = function PlotWaterfallIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 20 20' }, props),
        _react2.default.createElement('path', { d: 'M3.42 5.38h2.5v12.06h-2.5zM6.45 5.38H8.7v2.97H6.45zM11.93 2.57h2.16v9.69h-2.16zM9.16 8.12h2.2v4.13h-2.2zM14.67 2.57h2.35v14.86h-2.35zM5.92 5.38h.52v.22h-.52z' }),
        _react2.default.createElement('path', { d: 'M8.7 8.12h.52v.22H8.7zM11.27 12.03h.78v.22h-.78zM14.09 2.57h.78v.22h-.78z' })
    );
};

exports.default = PlotWaterfallIcon;